import { Expose } from 'class-transformer';
import { Model } from "../../../shared/models/model";

export class AVLSummary extends Model {
  @Expose() distance: number;
  @Expose() averageSpeed: number;
  @Expose() maxSpeed: number;
  @Expose() stopHours: number;
  @Expose() engineOn: number;
  @Expose() engineOff: number;
  @Expose() hardBraking: number;
  @Expose() drivingHours: number;

  constructor() {
    super();
  }
}
